import { useEffect, useReducer, useMemo } from 'react';
import useApi, { GET_CANNED_DASHBOARD_LIST } from 'hooks/useApi';
import { useHistory } from 'react-router-dom';
import { reducer, initialState } from './config';
import * as ACTIONS from './actions';

const useFetchCannedDashboardList = (masterObjectId, id) => {
  const [dashboardsSet, dispatch] = useReducer(reducer, initialState);
  const [state, makeRequest] = useApi();
  const { isLoading, isError, data } = state;
  const history = useHistory();

  useEffect(() => {
    const reqParams = GET_CANNED_DASHBOARD_LIST({ masterObjectId });
    makeRequest(reqParams);
  }, [makeRequest, masterObjectId]);

  useEffect(() => {
    function findDefaultDashboardId(dashboardsData) {
      const { dashboards } = dashboardsData;
      const defaultDashboard = dashboards.find(dashboard => dashboard.isDefaultScreen === true);

      if (defaultDashboard) {
        const { id: dashId } = defaultDashboard;
        return dashId;
      }

      const firstDashboard = dashboards.find(dashboard => dashboard.ordinal === 1);
      if (!firstDashboard) {
        return null;
      }

      const { id: dashId } = firstDashboard;
      return dashId;
    }

    if (isLoading) {
      // Dispatching action here should be implemented at some point even though this state's complexity and purpose might not need it
      return;
    }

    if (isError) {
      // Dispatching action here should be implemented for better error and state handling(reset the dashboard list values)
      return;
    }

    if (data) {
      dispatch({ type: ACTIONS.DASHBOARD_LIST_READY, payload: data });
      const defaultDashboardId = findDefaultDashboardId(data);

      if (!defaultDashboardId) {
        dispatch({ type: ACTIONS.SET_IS_EMPTY_LIST, payload: true });
      }
      // Redirect after the data for the new masterObjectId and the set of dashboards it owns has been retrieved in order to redirect to the correct URL in case the links or url only contains the masterObjectId
      if (defaultDashboardId && !id) {
        history.replace(`/canned/${masterObjectId}/${defaultDashboardId}`);
      }
    }
    // If the id gets included in the dependency array the user will get redirected before the defaultDashboardId and the data for the current masterObjectId have been retrieved and calculated and since the previous value still exists if the id becomes undefined
    // the redirect will be towards a wrong defaultDashboardId. Cleaning up the defaultDashboardId is an option but just not including the id as dep seems as a better option at this point
  }, [isLoading, isError, data, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  return [state, dashboardsSet, dispatch];
};
export default useFetchCannedDashboardList;
